import {gql, useSubscription} from '@apollo/client';
import {isEqual} from 'lodash';
import {useState} from 'react';
import {singletonHook} from 'react-singleton-hook';
import {SubLisaMonaParameters} from './__generated__/SubLisaMonaParameters';

const QUERY = gql`
  subscription SubLisaMonaParameters {
    parameter(subgraphError: allow, id: "global") {
      artEth
      hybridEth
      artDuration
      hybridDuration
      maxArtists
      maxArts
      maxHybrids
      artistsCount
      artsCount
      hybridsCount
    }
  }
`;

type Parameters = SubLisaMonaParameters['parameter'] & {loading: boolean};

export const useLisaMonaParameters = singletonHook({loading: true} as Parameters, () => {
  const [parameters, setParameters] = useState<Parameters>({} as Parameters);
  const {data, loading} = useSubscription<SubLisaMonaParameters>(QUERY);

  const p = data?.parameter;
  if (p) {
    const newParams = {
      loading,
      ...p,
    };

    if (!isEqual(parameters, newParams)) {
      setParameters(newParams);
    }
  }

  return parameters;
});
